import crypto from 'crypto';

const ALGO = process.env.REACT_APP_SSN_ALGORITHM || 'AES-256-CBC';
const KEY = process.env.REACT_APP_SSN_PUBLIC_KEY || '';

const decrypt = (text, ivBase64) => {
  try {
    const iv = Buffer.from(ivBase64, 'base64');
    const c = crypto.createDecipheriv(ALGO, KEY, iv);
    const d = c.update(text, 'base64', 'utf8');
    return d + c.final('utf8');
  } catch {
    return '';
  }
};

export default decrypt;
